<p-toast key="creationPiece"></p-toast>

<p-blockUI [blocked]="blocked">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-blockUI>


<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div #contenu *ngIf="EstCharge()">

	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 lg:col-6 my-2">
			<label for="lastname">Fournisseur<span class="requis">*</span></label>
			<p-dropdown [options]="listeFournisseurs" [(ngModel)]="prixFournisseur.fournisseur" optionLabel="nom" [virtualScroll]="true"
				[virtualScrollItemSize]="38" [showClear]="true" filter="true" filterBy="numero,nom"
				appendTo="body"
				placeholder="Sélectionner un fournisseur...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="prixFournisseur.fournisseur">
						<div class="flex align-items-center gap-2" tooltipPosition="left" pTooltip="{{prixFournisseur.fournisseur.nom}} ({{prixFournisseur.fournisseur.numero}})">
							<p-tag [severity]="fournisseurService.getQualityScore(prixFournisseur.fournisseur)"
							[value]="fournisseurService.getQualityScoreLabel(prixFournisseur.fournisseur)">
							</p-tag>
							<div>{{prixFournisseur.fournisseur.nom}} ({{prixFournisseur.fournisseur.numero}})</div>
						</div>
					</div>
				</ng-template>
				<ng-template let-fournisseur pTemplate="item">
					<div class="flex align-items-center gap-2" tooltipPosition="left" pTooltip="{{fournisseur.nom}} ({{fournisseur.numero}})">
						<p-tag [severity]="fournisseurService.getQualityScore(fournisseur)"
						[value]="fournisseurService.getQualityScoreLabel(fournisseur)">
						</p-tag>
						<div>{{fournisseur.nom}} ({{fournisseur.numero}})</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error" *ngIf="submitted && !prixFournisseur.fournisseur">Le fournisseur est
				obligatoire.</small>

		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2" *ngIf="prixFournisseur.fournisseur != null">
            <label for="noFournisseur">No pièce fournisseur</label>
            <input #champNoFournisseur type="text" pInputText id="noFournisseur" [(ngModel)]="prixFournisseur.numeroFournisseur"
                autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2" *ngIf="prixFournisseur.fournisseur != null">
            <label for="prix">Prix</label>
            <p-inputNumber #champPrix [(ngModel)]="prixFournisseur.prix" mode="currency" currency="USD" locale="en-US" [minFractionDigits]="2" [maxFractionDigits]="4"></p-inputNumber>
        </div>
	</div>


</div>


<div class="text-right mt-3">
	<button pButton pRipple label="Créer" icon="pi pi-save" class="p-button-primary"
	(click)="enregistrer()"></button>
<button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
	(click)="annuler()"></button>
	

</div>